import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: 'Home',
	component: () => import('../views/Home.vue'),
},
// {
// 	path: "*",
// 	name: "Home2",
// 	component: Home
// },
{
	path: '/home',
	name: 'Home3',
	component: () => import('../views/Home.vue'),
},
{
	path: '/about',
	name: 'About',
	component: () => import('../views/About.vue'),
	beforeEnter: (to, from, next) => {
		if (from.path === '/home') {
			// chrome
			document.body.scrollTop = 0
			// firefox
			document.documentElement.scrollTop = 0
			// safari
			window.pageYOffset = 0
		}
		next();
	}
},
{
	path: '/news',
	name: 'News',
	component: () => import('../views/News.vue'),
	meta: {
		keepAlive: true
	}
},
{
	path: '/newsDetail',
	name: 'NewsDetail',

	component: () => import('../views/newsDetail.vue')
},
{
	path: '/trade',
	name: 'Trade',
	component: () => import('../views/trade.vue'),
	meta: {
		keepAlive: true
	},
	beforeEnter: (to, from, next) => {
		if (from.path === '/home') {
			// chrome
			document.body.scrollTop = 0
			// firefox
			document.documentElement.scrollTop = 0
			// safari
			window.pageYOffset = 0
		}
		next();
	}
},
{
	path: '/tradeDetail',
	name: 'TradeDetail',
	component: () => import('../views/tradeDetail.vue')
},
{
	path: '/contact',
	name: 'Contact',
	component: () => import('../views/Contact.vue')
},
{
	path: '/market',
	name: 'Market',
	component: () => import('../views/market.vue'),
	beforeEnter: (to, from, next) => {
		if (from.path === '/home') {
			// chrome
			document.body.scrollTop = 0
			// firefox
			document.documentElement.scrollTop = 0
			// safari
			window.pageYOffset = 0
		}
		next();
	}
},
{
	path: '/operation',
	name: 'Operation',
	component: () => import('../views/operation.vue'),
	meta: {
		keepAlive: true
	},
	beforeEnter: (to, from, next) => {
		if (from.path === '/home') {
			// chrome
			document.body.scrollTop = 0
			// firefox
			document.documentElement.scrollTop = 0
			// safari
			window.pageYOffset = 0
		}
		next();
	}
},
{
	path: '/operationDetail',
	name: 'OperationDetail',
	component: () => import('../views/operationDetail.vue')
},
{
	path: '/build',
	name: 'Build',
	component: () => import('../views/build.vue'),
	meta: {
		keepAlive: true
	},
	beforeEnter: (to, from, next) => {
		if (from.path === '/home') {
			// chrome
			document.body.scrollTop = 0
			// firefox
			document.documentElement.scrollTop = 0
			// safari
			window.pageYOffset = 0
		}
		next();
	}
},
// {
// 	path: '/achievement',
// 	name: 'Achievement',
// 	component: () => import('../views/achievement.vue')
// },
{
	path: '/buildDetail',
	name: 'buildDetail',
	component: () => import('../views/buildDetail.vue')
},
{
	path: '/performance',
	name: 'performance',
	component: () => import('../views/performance.vue')
},
{
	path: '/projectCase',
	name: 'projectCase',
	component: () => import('../views/projectCase.vue')
},
{
	path: '/search',
	name: 'search',
	component: () => import('../views/search.vue')
}
]


const router = new VueRouter({
	mode: 'history',
	routes
})

//router3.0以上为 promise， 捕获错误
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error)
}
export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
  }

export default router
